export default [
    {
        path: "/",
        name: "Home",
        component: () => lazyLoadView(import("@views/Home.vue")),
    },
    {
        path: "/gateway/:gateway",
        name: "Gateway",
        component: () => lazyLoadView(import("@views/Gateway.vue")),
    },
    {
        path: "/schedule",
        name: "Schedule",
        component: () => lazyLoadView(import("@views/Schedule.vue")),
    },
    {
        path: "/analyzer",
        name: "Analyzer",
        component: () => lazyLoadView(import("@views/Analyzer.vue")),
    },
    {
        path: "/monitoring",
        name: "Monitoring",
        component: () => lazyLoadView(import("@views/Monitoring.vue")),
    },
    {
        path: "/login",
        name: "Login",
        component: () => lazyLoadView(import("@views/Login.vue")),
    },
];

function lazyLoadView(AsyncView) {
    const AsyncHandler = () => ({
        component: AsyncView,
        delay: 200,
        timeout: 10000,
        loading: require("@components/_loading.vue").default,
        error: require("@components/_timeout.vue").default,
    });

    return Promise.resolve({
        functional: true,
        render(h, { data, children }) {
            return h(AsyncHandler, data, children);
        },
    });
}
